import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ReduxState } from '../../interfaces';
import { useLifecycle } from '../../hooks/useLifecycle';
import Datatable from '../../modules/datatable/datatable';
import { getTrProps } from './columns';
import * as Devices from '../../modules/devices';
import * as Actions from '../../modules/devices/actions';
import RightPanel from '../shared/rightPanel';
import RightPanelSelector from '../shared/rightPanelSelector';
import ModalSelector from '../shared/modalSelector';
import { PanelsType, ModalsType, Modals } from '../../modules/dialogs/model';
import DataTableSummary from '../shared/datatable/summary';
import { setModal } from '../../modules/dialogs/actions';
import Scrim from '../shared/scrim';

interface StateProps {
  devicesState: Devices.State;
  activeDialog: PanelsType;
  activeModal: ModalsType;
}

type Props = StateProps;

const DevicesContent: React.FC<Props> = (props) => {
  useLifecycle('DeviceContent');

  useEffect(() => {
    props.devicesState.pagesToLoad.forEach((pageIdx) => {
      Actions.searchPage(pageIdx);
    });
  }, [props.devicesState.pagesToLoad]);

  return (
    <div className="layout__content__main" style={{ height: '100%' }}>
      <RightPanel
        isOpened={!!props.activeDialog}
        content={<RightPanelSelector activeDialog={props.activeDialog} />}
      >
        <DataTableSummary
          dtState={props.devicesState}
          clearSelection={Devices.clearSelection}
          msgMain={Devices.keyTotalDevices}
          editTableSettings={() => setModal(Modals.TABLE_SETTINGS)}
        />
        <Scrim
          isActive={props.devicesState.table.isLoading}
          fullHeight
          hideSpinner
        >
          <div className="layout__content__table_wrapper">
            <div className=" datatable__layout">
              <Datatable
                rows={props.devicesState.table.content}
                getPK={props.devicesState.selection.getPK}
                isLoading={false}
                columns={props.devicesState.table.columns}
                getTrProps={getTrProps(Actions.isTableItemSelected)}
                isSelectable
                allSelected={props.devicesState.selection.isAllSelected}
                onToggleItemSelection={Actions.updateTableItemSelection}
                isItemSelected={Actions.isTableItemSelected}
                onToggleAllSelected={Actions.updateTableSelectAll}
                pagination={props.devicesState.table.pagination}
                onPageChange={Actions.changeTablePage}
                onPageSizeChange={Actions.changeTableSizePage}
                sortCriteria={props.devicesState.sort}
                onSortCriteriaChanged={Actions.changeTableSorting}
              />
            </div>
          </div>
        </Scrim>
      </RightPanel>
      <ModalSelector activeModal={props.activeModal} />
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  devicesState: state.devicesState,
  activeDialog: state.dialogState.activeDialog,
  activeModal: state.dialogState.activeModal,
});

export default connect(mapStateToProps)(DevicesContent);
